import React from "react";
import { BsFillTelephoneFill } from "react-icons/bs";
import { HiOutlineMail } from "react-icons/hi";
import { HiPhone } from "react-icons/hi";

const Header = () => {
  return (
    <div className="flex w-full h-[8vh] justify-center items-center bg-[#F7F7F7] text-[#242424] border-b border-gray-200">
      <div className="container mx-auto px-4 flex flex-wrap items-center justify-between">
        <div className="flex items-center space-x-6">
          <div className="flex items-center group">
            <BsFillTelephoneFill className="text-yellow-500 mr-2 sm:text-[18px] text-[16px] group-hover:text-yellow-600 transition-colors duration-300" />
            <a
              href="tel:+994504071417"
              className="sm:text-[16px] text-[14px] hover:text-yellow-600 transition-colors duration-300 relative group"
            >
              (+994) 50 407 14 17
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-400 group-hover:w-full transition-all duration-300"></span>
            </a>
          </div>
          <div className="hidden md:flex items-center group">
            <HiOutlineMail className="text-yellow-500 mr-2 text-[18px] group-hover:text-yellow-600 transition-colors duration-300" />
            <a
              href="mailto:info@kabelmarket.az"
              className="text-[16px] hover:text-yellow-600 transition-colors duration-300 relative group"
            >
              info@kabelmarket.az
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-400 group-hover:w-full transition-all duration-300"></span>
            </a>
          </div>
        </div>

        <a
          href="/#contact"
          className="flex items-center bg-yellow-400 hover:bg-yellow-500 text-[#242424] sm:text-[15px] text-[14px] px-4 py-2 rounded-lg font-medium transition-colors duration-300 shadow-sm hover:shadow transform hover:-translate-y-0.5"
        >
          <HiPhone className="mr-2 text-[16px]" />
          Bizimlə Əlaqə
        </a>
      </div>
    </div>
  );
};

export default Header;
